'use client';
import ShieldKeyhole from '@public/svg/shield-keyhole.svg?component';
import ThumbsUp from '@public/svg/thumbs-up.svg?component';
import Truck from '@public/svg/truck.svg?component';
import clsx from 'clsx';

interface BuyNowIconsProps {
  className?: string;
  xs?: boolean;
}

export const BuyNowIcons: React.FC<BuyNowIconsProps> = ({ className, xs }) => {
  return (
    <div className={className}>
      <div className="flex flex-wrap justify-evenly items-center gap-x-3 gap-y-1">
        <div className="flex justify-start items-center">
          <Truck className={clsx('me-2', xs && 'w-[12px] sm:w-auto')} />
          <span className={clsx(xs ? 'responsive-text-12-16' : 'responsive-text-14-16')}>
            Free Shipping
          </span>
        </div>
        <div className="flex justify-start items-center">
          <ShieldKeyhole className={clsx('me-2', xs && 'w-[12px] sm:w-auto')} />
          <span className={clsx(xs ? 'responsive-text-12-16' : 'responsive-text-14-16')}>
            Privacy Guaranteed
          </span>
        </div>
        <div className="flex justify-start items-center">
          <ThumbsUp className={clsx('me-2', xs && 'w-[12px] sm:w-auto')} />
          <span className={clsx(xs ? 'responsive-text-12-16' : 'responsive-text-14-16')}>
            One-Time Purchase
          </span>
        </div>
      </div>
    </div>
  );
};
